import React from 'react';

export const CTASection = ({ onContact }) => {
  return (
    <section className="section-spacing bg-[#1a1a1a] text-center">
      <div className="revolt-container">
        <h2 className="section-title">Let's Tell Your Story Together</h2>
        <p className="subtitle mb-lg max-w-2xl mx-auto">
          I want to serve you throughout your day and entire planning process. 
          Together, let's document your memories and create images that help you relive your moments.
        </p>
        <button 
          onClick={onContact}
          className="hero-cta"
        >
          Get In Touch
        </button>
      </div>
    </section>
  );
};
